import * as Sentry from '@sentry/react'
import { createContext, useContext, useState, useEffect } from 'react'

const DepartmentContext = createContext()

export function useDepartment() {
  return useContext(DepartmentContext)
}

const DEPARTMENTS = [
  { id: 'kitchen', name: 'kitchen', displayName: 'Kitchen', isActive: true, businessId: 'desres', businessName: 'Desres Kitchen & Confectionery', businessLocation: 'Limpopo' },
  { id: 'bakery', name: 'bakery', displayName: 'Bakery', isActive: true, businessId: 'desres', businessName: 'Desres Kitchen & Confectionery', businessLocation: 'Limpopo' },
  { id: 'tuckshop', name: 'tuckshop', displayName: 'Tuck Shop', isActive: true, businessId: 'desres', businessName: 'Desres Kitchen & Confectionery', businessLocation: 'Limpopo' },
  { id: 'yawehs', name: 'yawehs', displayName: 'Bakery', isActive: true, businessId: 'yawehs', businessName: "Yahweh's Delight", businessLocation: 'Pretoria' },
]

export function DepartmentProvider({ children }) {
  const [departments, setDepartments] = useState(DEPARTMENTS)
  const [currentDepartment, setCurrentDepartment] = useState(() => {
    const saved = sessionStorage.getItem('currentDepartment')
    return saved || null
  })

  useEffect(() => {
    if (currentDepartment) {
      sessionStorage.setItem('currentDepartment', currentDepartment)
    }
  }, [currentDepartment])

  const selectDepartment = (deptName) => {
    const dept = departments.find(d => d.name === deptName)
    if (dept?.isActive) {
      setCurrentDepartment(deptName)
      Sentry.setTag('department', deptName)
    }
  }

  const activateDepartment = (deptName) => {
    setDepartments(prev =>
      prev.map(d => d.name === deptName ? { ...d, isActive: true } : d)
    )
  }

  const clearDepartment = () => {
    setCurrentDepartment(null)
    sessionStorage.removeItem('currentDepartment')
  }

  const dept = departments.find(d => d.name === currentDepartment) || null

  return (
    <DepartmentContext.Provider value={{
      departments,
      currentDepartment: dept,
      currentDepartmentId: currentDepartment,
      selectDepartment,
      clearDepartment,
      activateDepartment,
      isDepartmentSelected: !!currentDepartment,
    }}>
      {children}
    </DepartmentContext.Provider>
  )
}
